<script>
import thumbnailYoutubeVimeo from "thumbnail-youtube-vimeo";

export default {
  props: ["videoUrl", "fallbackImage"],

  data() {
    return {
      loaded: false,
      thumbUrl: null,
    };
  },

  computed: {
    src() {
      if (!this.loaded) {
        return null;
      }

      return this.thumbUrl ? this.thumbUrl : this.fallbackImage;
    },
  },

  mounted() {
    if (!this.videoUrl) {
      this.loaded = true;
    }

    const vm = this;

    thumbnailYoutubeVimeo(this.videoUrl).then(
      (result) => {
        this.loaded = true;
        this.thumbUrl = result;
      },
      (err) => {
        axios
          .get("https://vimeo.com/api/oembed.json?url=" + this.videoUrl)
          .then((response) => {
            this.thumbUrl = response.data.thumbnail_url;
            this.loaded = true;
          })
          .catch(() => {
            this.loaded = true;
          });
      }
    );
  },

  render() {
    return this.$scopedSlots.default({
      src: this.src,
      loaded: this.loaded,
      hasThumb: this.thumbUrl ? true : false,
    });
  },
};
</script>
